@if (!isAnalyticsPanelOpen) {
  <mds-sidebar-organisms
    [productName]="productName"
    [productType]="productType"
    [selectionText]="selectionText"
    [contextualTools]="contextualTools"
    [modelTools]="modelTools"
    [alternatives]="alternatives"
    [headIconColors]="headerIconColor"
    [chipContent]="chipContent"
    (linkClick)="openTool($event)"
    (isSidePanelOpen)="checkToggle($event)"
    [stage]="stage"
    [aiGeneratedProduct]="aiGenerated"
    [aiValidationStatus]="aiValidationStatus"
    (onClickAIValidate)="onValidateProduct()"
    [updatingAIStatus]="updatingAIStatus"
  ></mds-sidebar-organisms>
}
@if (isAnalyticsPanelOpen) {
  <app-performance-analytics
    (isSidePanelOpen)="checkToggle($event)"
    [data]="analyzeData"
    [app]="app"
  ></app-performance-analytics>
}
